import { lazy } from "react";
import Login from "../Views/Auth/Login";
import PublicAuth from "./PublicAuth";
import SingleOrGroup from "../Views/Main/MakeOrder/SingleOrGroup";
const MakeOrder = lazy(() => import("../Views/Main/MakeOrder/MakeOrder"));

export const PublicRoutes = () => {
  return [
    {
      element: <PublicAuth />,
      children: [
        {
          path: "/",
          element: <Login />,
        },
        {
          path: "/order-by-customer",
          element: <MakeOrder />,
        },
        {
          path: "/single-or-group",
          element: <SingleOrGroup />,
        },
      ],
    },
  ];
};
